import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";

const QUOTE = "We cut garments the way architects draw rooms — with space left over for the person inside.".split(" ");

const Word = ({ w, i, total, progress }) => {
  const start = i / total;
  const opacity = useTransform(progress, [start * 0.7, start * 0.7 + 0.25], [0.18, 1]);
  return <motion.span style={{ opacity }} className="mr-[0.25em] inline-block">{w}</motion.span>;
};

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const textProgress = useTransform(scrollYProgress, [0.1, 0.6], [0, 1]);
  const imgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} data-testid="manifesto-section" className="relative overflow-hidden bg-ink text-bone">
      <div className="mx-auto grid max-w-[1600px] gap-12 px-5 py-24 md:grid-cols-12 md:px-10 md:py-40">
        <div className="md:col-span-7">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-400">Manifesto</p>
          <p className="mt-8 font-display text-4xl font-light leading-[1.08] md:text-6xl">
            {QUOTE.map((w, i) => <Word key={i} w={w} i={i} total={QUOTE.length} progress={textProgress} />)}
          </p>
          <Link to="/shop?category=hoodies" data-testid="manifesto-cta" className="mt-12 inline-flex rounded-full border border-bone/50 px-7 py-4 text-sm transition-colors duration-300 hover:bg-bone hover:text-ink">
            Shop hoodies
          </Link>
        </div>
        <div className="relative md:col-span-4 md:col-start-9">
          <div className="relative aspect-[3/4] overflow-hidden [clip-path:polygon(0_6%,100%_0,100%_94%,0_100%)]">
            <motion.img src="/img/textiles.jpg" alt="Folded knit textiles" style={{ y: imgY }} className="absolute inset-0 h-[124%] w-full -translate-y-[10%] object-cover" />
          </div>
          <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-400">Fig. 04 — Material study</p>
        </div>
      </div>
    </section>
  );
};
